<template>
  <div>
    <h4>Boleto</h4>
    <div class="mt-2 mb-4">
      Um e-mail com os dados do pedido será enviado para <strong>{{ basket.email }}</strong>
    </div>

    <div class="mb-2">
      <vs-input class="w-full" label="Nome Completo" placeholder="Nome Completo" v-model="basket.name" />
    </div>

    <WhatsAppPhoneInput :basket="basket" />

    <div class="mb-2">
      <vs-input
        class="w-full"
        label="CPF/CNPJ"
        placeholder="Somente números"
        v-model="basket.cpfcnpj"
      />
    </div>
    <div class="mb-2">
      <vs-input
        class="w-full"
        label="CEP"
        placeholder="CEP"
        v-model="basket.address_postcode"
        @input="checkCep"
      />
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-4/5 mr-4">
          <vs-input class="w-full" label="Rua, Avenida" placeholder="Rua, Avenida" v-model="basket.address_street" />
        </div>
        <div class="w-1/5">
          <vs-input class="w-full" label="Número" placeholder="Número" v-model="basket.address_number" />
        </div>
      </div>
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-2/5 mr-4">
          <vs-input class="w-full" label="Bairro" placeholder="Bairro" v-model="basket.address_complement" />
        </div>
        <div class="w-2/5 mr-4">
          <vs-input class="w-full" label="Cidade" placeholder="Cidade" v-model="basket.address_city" />
        </div>
        <div class="w-1/5">
          <vs-input class="w-full" label="Estado" placeholder="UF" v-model="basket.address_state" />
        </div>
      </div>
    </div>

    <vs-button type="relief" class="w-full mt-6" @click="pay">Continuar</vs-button>
  </div>
</template>

<script>
import WhatsAppPhoneInput from '../WhatsAppPhoneInput.vue';
import { checkoutLog } from '../../utils/checkoutDebug';

export default {
  components: {
    WhatsAppPhoneInput
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: false
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.syncBasketIdentity();
    checkoutLog('gateway:mounted', { gateway: 'Ticket', paymentMethod: this.paymentMethod }, this.$route);
  },
  methods: {
    syncBasketIdentity() {
      if (!this.basket.name) {
        this.basket.name = [this.basket.firstname, this.basket.lastname].filter(Boolean).join(' ').trim();
      }
    },
    validateBasket() {
      this.syncBasketIdentity();

      const cep = String(this.basket.address_postcode || '').replace(/\D/g, '');
      const cpf = String(this.basket.cpfcnpj || '').replace(/\D/g, '');
      const state = String(this.basket.address_state || '')
        .replace(/[^a-zA-Z]/g, '')
        .slice(0, 2)
        .toUpperCase();

      if (cep.length === 8) {
        this.basket.address_postcode = cep;
      }
      if (state.length === 2) {
        this.basket.address_state = state;
      }
      if (cpf) {
        this.basket.cpfcnpj = cpf;
      }
      if (!String(this.basket.address_complement || '').trim()) {
        this.basket.address_complement = 'Centro';
      }

      const missing = [];
      if (!String(this.basket.name || '').trim()) missing.push('Nome completo');
      if (!String(this.basket.email || '').trim()) missing.push('E-mail');
      if (cpf.length !== 11 && cpf.length !== 14) missing.push('CPF/CNPJ válido');
      if (!String(this.basket.address_street || '').trim()) missing.push('Rua');
      if (!String(this.basket.address_number || '').trim()) missing.push('Número');
      if (cep.length !== 8) missing.push('CEP válido');
      if (!String(this.basket.address_city || '').trim()) missing.push('Cidade');
      if (state.length !== 2) missing.push('Estado (UF)');

      return missing;
    },
    buildOrderBasket() {
      const plans = (this.basket.plans || []).map(plan => ({
        ...plan,
        quantity: parseInt(plan.quantity, 10) > 0 ? parseInt(plan.quantity, 10) : 1
      }));

      return {
        ...this.basket,
        plans
      };
    },
    collectApiErrors(error) {
      const errors = [];
      const data = error.response && error.response.data;

      if (!data) {
        return ['Não foi possível processar seu pedido. Tente novamente.'];
      }

      if (data.message) {
        errors.push(data.message);
      }

      Object.keys(data).forEach(key => {
        if (key === 'message') {
          return;
        }
        const value = data[key];
        if (Array.isArray(value)) {
          value.forEach(item => errors.push(item));
        } else if (typeof value === 'string') {
          errors.push(value);
        }
      });

      return errors.length
        ? errors
        : ['Não foi possível processar seu pedido. Verifique os dados e tente novamente.'];
    },
    checkCep() {
      const cep = String(this.basket.address_postcode || '').replace(/[^0-9]/g, '');
      if (cep.length === 8) {
        this.$api.post('/api/v1/checkout/cep', { cep }).then(response => {
          if (response.data && response.data.logradouro) {
            this.basket.address_street = response.data.logradouro;
            this.basket.address_city = response.data.cidade;
            this.basket.address_complement = response.data.bairro;
            this.basket.address_state = response.data.estado;
          }
        });
      }
    },
    pay() {
      const missing = this.validateBasket();
      if (missing.length) {
        this.$vs.notify({
          time: 6000,
          text: 'Preencha: ' + missing.join(', '),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        });
        return;
      }

      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/create', {
          payment_method: this.paymentMethod,
          basket: this.buildOrderBasket(),
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          if (response.data && parseInt(response.data.orderId) > 0) {
            window.location.href =
              '/checkout/complete?orderId=' + response.data.orderId + '&orderNumber=' + response.data.orderNumber;
          } else {
            this.basket.processing = false;
            this.$vs.notify({
              time: 6000,
              text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
        .catch(error => {
          this.basket.processing = false;
          this.$vs.notify({
            time: 6000,
            text: this.collectApiErrors(error).join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
